import { render, staticRenderFns } from "./CheckScore.vue?vue&type=template&id=9480643c&scoped=true&"
import script from "./CheckScore.vue?vue&type=script&lang=js&"
export * from "./CheckScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9480643c",
  null
  
)

export default component.exports